import { API } from "@swivl-mono/api-helper";
import { LocationScope, LocationVarKey, SpotData, SpotDataButton } from "@swivl-mono/types";
import { SpotMainLayoutComponent } from "@swivl-mono/ui";
import { useEffect, useMemo, useState } from "react";

import { useMergedLocationVariables } from "../../../Hooks/useLocationVariables";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";
import BrandsModel from "../../../Models/Brands/Brands.Model";
import LocationVarsModel from "../../../Models/Variables/LocationVars.Model";
import { SpotButtonsView } from "./Buttons/Spot.Buttons.View";
import { SpotButtonControls } from "./Sidebar/Spot.Button.Controls";
import { SpotSidebarControls } from "./Sidebar/Spot.Sidebar.Controls";
import "./Spot.View.scss";

export function SpotView() {
  const page = usePropertiesGetLocationIds();
  const isLocationPage = page.type === LocationScope.LOCATION;
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [data, setData] = useState<SpotData | null>(null);
  const [selectedButtonId, setSelectedButtonId] = useState<string | undefined>(undefined);

  const brands = BrandsModel.useState((state) => state.brands);

  useEffect(() => {
    BrandsModel.load(false);
  }, []);

  const vars = useMergedLocationVariables(
    [LocationVarKey.SpotBrandSlug, LocationVarKey.SpotLocationSlug, LocationVarKey.SpotButtons],
    page.groupId,
    page.locationId
  );

  const buttons = useMemo(() => {
    if (vars && vars[LocationVarKey.SpotButtons]) {
      try {
        return JSON.parse(vars[LocationVarKey.SpotButtons].value) as SpotDataButton[];
      } catch (e) {
        console.error("Error parsing SpotData", e);
      }
    }
    return undefined;
  }, [vars]);

  const setButtons = async (data: SpotDataButton[]) => {
    if (vars && vars[LocationVarKey.SpotButtons] && vars[LocationVarKey.SpotButtons].id) {
      const value = JSON.stringify(data);
      await LocationVarsModel.saveVariable(vars[LocationVarKey.SpotButtons].id, value);
    }
  };

  console.warn("I think that the spot button data will not change right now on changing locations. fix this soon");

  const { locationSlug, brandSlug } = useMemo(() => {
    if (vars) {
      return {
        locationSlug: vars[LocationVarKey.SpotLocationSlug]?.value,
        brandSlug: vars[LocationVarKey.SpotBrandSlug].value
      };
    }
    return { locationSlug: null, brandSlug: null };
  }, [vars]);

  useEffect(() => {
    if (vars && vars[LocationVarKey.SpotBrandSlug]) {
      if (isLocationPage) {
        if (vars[LocationVarKey.SpotLocationSlug]) {
          API.Spot.getLocation(vars[LocationVarKey.SpotBrandSlug].value, vars[LocationVarKey.SpotLocationSlug].value).then((data) => {
            setData(data);
          });
        }
      } else {
        API.Spot.getBrand(vars[LocationVarKey.SpotBrandSlug].value).then((data) => {
          setData(data);
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationSlug, brandSlug]);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(true);
    setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y });
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    e.preventDefault();
    if (isDragging) {
      const dx = e.clientX - position.x;
      const dy = e.clientY - position.y;
      setOffset({ x: dx, y: dy });
    }
  };

  const handleMouseUp = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDragging(false);
    setPosition({ x: e.clientX - offset.x, y: e.clientY - offset.y });
  };

  return (
    <>
      <div
        key={"graphPaperBg" + page.path}
        className="graphPaperBg absolute inset-0 overflow-auto"
        onClick={() => {
          setSelectedButtonId(undefined);
        }}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        style={{
          cursor: isDragging ? "grabbing" : "grab"
        }}
      />
      <div className="SpotView" style={{ transform: `translate(${offset.x}px, ${offset.y}px)` }}>
        {data && (
          <div className="absolute right-20 left-10 p-10 shadow-lg" style={{ width: "500px", height: "80vh", overflow: "hidden" }}>
            <SpotMainLayoutComponent key={"mainlayout" + page.path} position="absolute" data={data} rounded={true}>
              <SpotButtonsView
                page={page}
                buttons={buttons}
                setSelectedButtonId={setSelectedButtonId}
                selectedButtonId={selectedButtonId}
                buttonsVar={vars?.SpotButtons}
                setButtons={setButtons}
              />
            </SpotMainLayoutComponent>
          </div>
        )}
      </div>
      <div className="top-20vh fixed right-0 h-full w-96 bg-white shadow-[-4px_2px_8px_rgba(0,0,0,0.1)]">
        {selectedButtonId && buttons ? (
          <SpotButtonControls buttons={buttons} setButtons={setButtons} selectedButtonId={selectedButtonId} />
        ) : (
          <SpotSidebarControls page={page} brands={brands} />
        )}
      </div>
    </>
  );
}
